import type { FC, ReactNode } from 'react'
import type { VideoCard as VideoCardData, VideoType } from '@/types/content'

import { useState } from 'react'
import { cn } from '@/lib/utils'
import { videoTypeLabels } from '@/lib/labels'
import { VideoCard } from '@/components/media/video-card'

const order: Array<VideoType> = ['official', 'lyric', 'visualiser', 'animated', 'short_film', 'experimental']

export const VideoLibrary: FC<{ videos: Array<VideoCardData> }> = ({ videos }): ReactNode => {
    const [type, setType] = useState<VideoType | 'all'>('all')
    const available = order.filter(item => videos.some(video => video.video_type === item))
    const shown = type === 'all' ? videos : videos.filter(video => video.video_type === type)
    const [lead, ...rest] = shown

    return (
        <div>
            {available.length > 1 && (
                <div role='group' aria-label='Video type' className='no-scrollbar mb-12 flex gap-1 overflow-x-auto'>
                    {(['all', ...available] as Array<VideoType | 'all'>).map(item => (
                        <button
                            key={item}
                            type='button'
                            onClick={() => setType(item)}
                            aria-pressed={type === item}
                            className={cn('h-10 shrink-0 rounded-full px-5 text-xs transition', type === item ? 'bg-ivory text-obsidian' : 'border border-ivory/12 text-ivory/70 hover:border-ivory/30 hover:text-ivory')}
                        >
                            {item === 'all' ? 'Everything' : videoTypeLabels[item]}
                        </button>
                    ))}
                </div>
            )}

            {!lead ? (
                <div className='rounded-2xl border border-dashed border-white/10 px-6 py-20 text-center'>
                    <p className='font-heading text-3xl'>The first films are being made.</p>
                    <p className='mx-auto mt-3 max-w-md text-sm text-muted-foreground'>Music videos, lyric videos and visualisers will appear here as they are released.</p>
                </div>
            ) : (
                <>
                    <VideoCard video={lead} size='lg' priority />

                    {rest.length > 0 && (
                        <div className='mt-16 grid gap-x-8 gap-y-14 sm:grid-cols-2 lg:grid-cols-3'>
                            {rest.map(video => (
                                <VideoCard key={video.id} video={video} className='reveal' />
                            ))}
                        </div>
                    )}
                </>
            )}
        </div>
    )
}
